module.exports = __webpack_public_path__ + "img/addon.svg";